import React, { useState, useEffect, useRef } from 'react';
import workshopsData from '../data/workshops';
import WorkshopCard from './WorkshopCard';
import WorkshopModal from './WorkshopModal';

function WorkshopsSection() {
  const [selected, setSelected] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const gridRef = useRef(null);

  useEffect(() => {
    const el = gridRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="workshops"
      className="bg-gray-100 text-blue-900 py-16 px-8 text-center"
    >
      <h2 className="text-3xl font-bold mb-10">
        Warsztaty podczas VI Zimowiska Enklawy
      </h2>

      <div ref={gridRef} className="max-w-6xl mx-auto grid gap-6 sm:grid-cols-2 lg:grid-cols-3 items-stretch">
        {workshopsData.map((w, i) => (
          <WorkshopCard key={w.id} workshop={w} onOpen={setSelected} index={i} isVisible={isVisible} />
        ))}
      </div>

      <WorkshopModal workshop={selected} onClose={() => setSelected(null)} />
    </section>
  );
}

export default WorkshopsSection;
